import React, { useState } from 'react';
import OwnDetails from './OwnDetails';
import PetDetails from './PetDetails';
import MaskedInput from 'react-text-mask';
import Select from 'react-select';
import { useSharedDataContext } from '../SharedDataContext';
import { useEffect } from 'react';
import { isMobileNotValid, getAgeList } from '../utility/utilityFunction';
import { centralCall } from '../../api';

const EditDetailsModal = ({ getUpdatedDetails, onClose }) => {
    const [ErrorMSG, setErrorMSG] = useState({});
    const [petDetailsObj, setPetDetailsObj] = useState({});
    const [ownerDetailsObj, setOwnerDetailsObj] = useState({});
    const [pincode, setPincode] = useState("");
    const [breedCategory, setBreedCategory] = useState('');
    const [btnVal, setBtnVal] = useState("Submit");
    const [isBtnDisabled, setBtnDisabled] = useState(false);
    const [ageListData, setAgeListData] = useState({});
    const { sharedData, setSharedData } = useSharedDataContext();
    const { breedList } = sharedData;



    useEffect(() => {
        const { petname, petbreed, breedCategory, petage, petagemonth, pincode, petgender, petweight, ownername, mobileno } = sharedData;
        setOwnerDetailsObj({ ...ownerDetailsObj, ownerName: ownername, mobileNo: mobileno });
        setPetDetailsObj({ ...petDetailsObj, petName: petname, breed: petbreed, petAgeYear: petage, petAgeMonth: petagemonth, petGender: petgender, petWeight: petweight });
        setBreedCategory(breedCategory);
        setPincode(pincode);
        setBtnDisabled(true);

        let monthList = getAgeList(false);
        let yearList = getAgeList(true);
        setAgeListData({ monthList, yearList });
    }, []);

    

    useEffect(() => {
        const { ownerName, mobileNo } = ownerDetailsObj;
        const { petName, breed, petAgeMonth, petAgeYear, petGender, petWeight } = petDetailsObj;
        const { petname, petbreed, breedCategory, petage, petagemonth, petgender, petweight, ownername, mobileno } = sharedData;

        if (petname === petName && petbreed === breed && breedCategory === sharedData.breedCategory &&
            petage === petAgeYear && petagemonth === petAgeMonth && pincode === sharedData.pincode && petgender === petGender &&
            petweight === petWeight && ownername === ownerName && mobileno === mobileNo) {
            setBtnDisabled(true);
        } else {
            setBtnDisabled(false);
        }

    }, [petDetailsObj, ownerDetailsObj, pincode])

    const handleOwnerDetailValue = (e) => {
        const { name, value } = e.target;
        setOwnerDetailsObj({ ...ownerDetailsObj, [name]: value });
    }
    const handlePetDetailValue = (e) => {
        const { name, value } = e.target;
        setPetDetailsObj(prev=>({ ...prev, [name]: value }));
        if (name === "petAgeYear" && value.split(" ")[0] === "0") {
            const petAgeMonthValue = parseInt(petDetailsObj.petAgeMonth.split(" ")[0]);
            if (petAgeMonthValue < 3) {
                setPetDetailsObj(prev=>({ ...prev, petAgeMonth: "" }));
            }
        } else if (name === "petAgeYear" && value.split(" ")[0] === "10") {
            setPetDetailsObj(prev=>({ ...prev, petAgeMonth: "0 Month" }));
        }
    }

    const handleIsWeight = (selectedweight) => {
        setPetDetailsObj({ ...petDetailsObj, petWeight: selectedweight });

        if (parseInt(selectedweight) <= 10) {
            setBreedCategory("Small");
        } else if (parseInt(selectedweight) <= 25 && parseInt(selectedweight) > 10) {
            setBreedCategory("Medium");
        }
        else if (parseInt(selectedweight) <= 40 && parseInt(selectedweight) > 25) {
            setBreedCategory("Large");
        }
        else if (parseInt(selectedweight) > 40) {
            setBreedCategory("Giant");
        }

    }



    const bindCityStateNameByPin = (pincode) => {
        setPincode(pincode);
        if (pincode.length === 6) {
            centralCall({ URL: `/api/Binding/GetStateCityListByPincode?pincode=${pincode}` }).then(res => {
                if (res.data.StatusCode == "200") {
                    const data = res.data.Data[0];
                    setSharedData({ ...sharedData, stateName: data.State, cityName: data.City });
                    if (data) { setErrorMSG({ ...ErrorMSG, pincode: "" }); }
                }
            });
           

        } else {
            setSharedData({ ...sharedData, stateName: "", cityName: "" });
        }
    }


    const updateEditedDetails = (e) => {
        const { ownerName, mobileNo } = ownerDetailsObj;
        const { petName, breed, petAgeMonth, petAgeYear, petGender, petWeight } = petDetailsObj;

        e.preventDefault();
        let ErrorMSG = {};
        let goto = true;
        if (ownerName.trim() === "" || ownerName === undefined || ownerName === null) {
            ErrorMSG["ownerName"] = "Please enter owner name";
            goto = false;
        }
        if (mobileNo === "" || mobileNo === undefined || mobileNo === null) {
            ErrorMSG["mobileNo"] = "Please enter mobile number";
            goto = false;
        } else if (mobileNo.length !== 10 || isMobileNotValid(mobileNo)) {
            ErrorMSG["mobileNo"] = "Please enter valid mobile number";
            goto = false;
        }
        if (petName.trim() === "" || petName=== undefined || petName === null) {
            ErrorMSG["petName"] = "Please enter your pet name";
            goto = false;
        }
        if (breed === "" || breed === undefined || breed === null) {
            ErrorMSG["breed"] = "Please select breed of your pet";
            goto = false;
        }
        if (breedCategory === "" || breedCategory === undefined || breedCategory === null) {
            ErrorMSG["breedCategory"] = "Please select breed category of your pet";
            goto = false;
        }
        if (petAgeYear === "" || petAgeYear === undefined || petAgeYear === null) {
            ErrorMSG["petAgeYear"] = "Please select age year of your pet";
            goto = false;
        } else if (petAgeYear =="0 Year" && petAgeMonth =="") {
            ErrorMSG["petAgeMonth"] = "Please select age month of your pet";
            goto = false;
        }
      /*  if (petAgeMonth === "" || petAgeMonth === undefined || petAgeMonth === null) {
            ErrorMSG["petAgeMonth"] = "Please select age month of your pet";
            goto = false;
        }*/
        if (petGender === "" || petGender === undefined || petGender === null) {
            ErrorMSG["petGender"] = "Please select gender of your pet";
            goto = false;
        }
        if (petWeight === "" || petWeight === undefined || petWeight === null) {
            ErrorMSG["petWeight"] = "Please select weight of your pet";
            goto = false;
        }
        if (petAgeYear && petWeight) {
            if ((petAgeYear.split(" ")[0] > 7 && petWeight > 40) || (petAgeYear.split(" ")[0] == 7 && petAgeMonth.split(" ")[0] > 0 && petWeight > 40)) {
                ErrorMSG["petWeight"] = "Pets exceeding 40 kg in weight can be insured up to the age of 7 years.";
                goto = false;
            }
        }
        if (pincode === "" || pincode === undefined || pincode === null) {
            ErrorMSG["pincode"] = "Please enter PIN code";
            goto = false;
        } else if (pincode.length !== 6) {
            ErrorMSG["pincode"] = "Please enter valid PIN code";
            goto = false;
        }

        setErrorMSG(ErrorMSG);

        if (goto) {
            setBtnVal("Wait...")

            const updatedData = {
                ...sharedData,
                petname: petName,
                petbreed: breed,
                breedCategory: breedCategory,
                petage: petAgeYear,
                petagemonth: petAgeMonth,
                pincode,
                petgender: petGender,
                petweight: petWeight,
                ownername: ownerName,
                mobileno: mobileNo
            }
            let data = {
                ownerDetailsObj,
                petDetailsObj,
                updatedData
            }
            if (sharedData?.ownerDetailsObj) {
                updatedData.ownerDetailsObj = { ...sharedData.ownerDetailsObj, OwnerName: ownerName, MobileNo: mobileNo, Pincode: pincode }
            }
            if (sharedData?.petDetailsObj) {
                updatedData.petDetailsObj = { ...sharedData.petDetailsObj, PetName: petName, PetAge: petAgeYear, PetAgeMonth: petAgeMonth, PetGender: petGender == "Male" ? "M" : "F", PetWeight: petWeight, PetBreed: breed }
            }
            setSharedData(updatedData);

            getUpdatedDetails(data);
        }
    }

    return (
        <>
            <div className="EditDetails">
                <div className="SameForm SameForm2 EditDetailsBox">
                    <div className="EditDetailsHead">
                        <h2 className="formHeading">Edit Details</h2>
                        <button type="button" className="clsBtn" data-dismiss="modal" onClick={()=> onClose() }>
                            <img src={require("../../assets/images/Cross.svg").default} alt="Cross Icon" />
                        </button>
                    </div>
                    <div className="EditDetailsBody">
                        <h3 className="formHeading">Owner Details</h3>
                        <div className="PetInput">
                            <MaskedInput
                                mask={[/[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/]}
                                guide={false} showMask={false}
                                placeholder=" " id="ForUp1" className="InputBox mt-3"
                                name="ownerName"
                                value={ownerDetailsObj.ownerName}
                                onChange={handleOwnerDetailValue}
                            />
                            <label htmlFor="ForUp1" className="floating_label pt-2">Owner Name</label>
                            <div className="inputIcon">
                                <img src={require("../../assets/images/user.svg").default} alt="" />
                            </div>
                            <span className="Error">{ErrorMSG["ownerName"]}</span>
                        </div>
                        <div className="PetInput">
                            <MaskedInput type="tel"
                                mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                name="mobileNo"
                                minLength="10"
                                value={ownerDetailsObj.mobileNo}
                                onChange={handleOwnerDetailValue}
                                guide={false} showMask={false} style={{ textTransform: "uppercase" }} placeholder=" " id="ForUp2" className="InputBox" />
                            <label htmlFor="ForUp2" className="floating_label">Your Mobile Number</label>
                            <div className="inputIcon">
                                <img src={require("../../assets/images/mobile.svg").default} alt="" />
                            </div>
                            <span className="Error">{ErrorMSG["mobileNo"]}</span>
                        </div>
                        <h3 className="formHeading">Pet Details</h3>
                        <div className="PetInput">
                            <MaskedInput
                                mask={[/[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/]}
                                guide={false} showMask={false}
                                placeholder=" " id="ForUp1" className="InputBox mt-3"
                                name="petName"
                                value={petDetailsObj.petName}
                                onChange={handlePetDetailValue}
                            />
                            <label htmlFor="ForUp1" className="floating_label pt-2">Pet Name</label>
                            <div className="inputIcon">
                                <img src={require("../../assets/images/dog.svg").default} alt="" />
                            </div>
                            <span className="Error">{ErrorMSG["petName"]}</span>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="PetInput">
                                    <Select
                                        inputId="petBreed"
                                        value={petDetailsObj.breed ? { label: petDetailsObj.breed, value: petDetailsObj.breed } : null}
                                        options={breedList?.map(breed => ({ label: breed.Breed, value: breed.Breed }))}
                                        onChange={(selectedOption) => setPetDetailsObj({ ...petDetailsObj, breed: selectedOption.value })}
                                        placeholder="Select Your Pet Breed" className="InputBox"
                                    />
                                    <label htmlFor="petBreed" className="floating_label mt-2">Select Breed</label>
                                    <span className="Error">{ErrorMSG["breed"]}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="PetInput">
                                    <select className="InputBox SpaceInPlaceHolder"
                                        name="petAgeYear"
                                        value={petDetailsObj.petAgeYear}
                                        onChange={handlePetDetailValue}
                                    >
                                        <option value="">Select Age</option>
                                        {ageListData?.yearList?.map((age, ind) => < option key={ind}>{age.value}</option>)}
                                    </select>
                                    <label>Select Your Pet Age (Year)</label>
                                    <span className="Error">{ErrorMSG["petAgeYear"]}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="PetInput">
                                    <select className="InputBox SpaceInPlaceHolder"
                                        name="petAgeMonth"
                                        value={petDetailsObj.petAgeMonth}
                                        onChange={handlePetDetailValue}
                                    >
                                        <option value="">Select Age</option>
                                        {ageListData?.monthList?.map((age, ind) => petDetailsObj.petAgeYear?.split(" ")[0] == 0 ? (age?.value?.split(" ")[0] > 2) && <option key={ind} value={age.value}>{age.value}</option> : petDetailsObj.petAgeYear?.split(" ")[0] == 10 ? (age?.value?.split(" ")[0] == 0) && <option key={ind} value={age.value}>{age.value}</option> :<option key={ind} value={age.value}>{age.value}</option>)}
                                    </select>
                                    <label>Select Your Pet Age (Month)</label>
                                    <span className="Error">{ErrorMSG["petAgeMonth"]}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/*<div className="col-md-6">
                                <div className="PetInput">
                                    <select className="InputBox"
                                        name="petGender"
                                        value={petDetailsObj.petGender}
                                        onChange={handlePetDetailValue}
                                    >
                                        <option>Select Gender</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                    </select>
                                    <label>Select your pet Gender</label>
                                    <span className="Error">{ErrorMSG["petGender"]}</span>
                                </div>
                            </div>
                            */}
                            <div className="col-md-12">
                                <label>Select Your Pet Gender</label>
                                <div className="d-flex ">
                                    <div className="me-2">
                                        <input className="" type="radio" name="petGender" value='Male' id="Male" checked={petDetailsObj.petGender == "Male"} onChange={handlePetDetailValue} />
                                        <label className="form-check-label mx-1" htmlFor="Male">
                                            Male
                                        </label>
                                    </div>
                                    <div className="">
                                        <input className="" type="radio" name="petGender" id="Female" value="Female" checked={petDetailsObj.petGender == "Female"} onChange={handlePetDetailValue} />
                                        <label className="form-check-label mx-1" htmlFor="Female">
                                            Female
                                        </label>
                                    </div>
                                </div>
                                <span className="Error">{ErrorMSG["petGender"]}</span>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-12">
                                <div className="PetInput">
                                    <MaskedInput type="text"
                                        name="petWeight"
                                        mask={[/[0-9]/, /\d/]}
                                        guide={false} showMask={false}
                                        value={petDetailsObj.petWeight}
                                        onChange={e => handleIsWeight(e.target.value)}
                                        placeholder=" " id="ForUp20" className="InputBox" />
                                    {petDetailsObj.petWeight && <span class="weight_unit">KG</span>}
                                    <label htmlFor="ForUp20">Select Your Pet Weight</label>
                                    <span className="Error">{ErrorMSG["petWeight"]}</span>
                                </div>
                            </div>
                        </div>
                        <div className="PetInput">
                            <MaskedInput type="tel"
                                name="Pincode"
                                mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                guide={false} showMask={false}
                                value={pincode}
                                onChange={e => bindCityStateNameByPin(e.target.value)}
                                placeholder=" " id="ForUp2" className="InputBox" />
                            <div className="inputIcon">
                                <img src={require("../../assets/images/location.svg").default} alt="" />
                            </div>
                            <label htmlFor="ForUp2" className="floating_label">PIN code</label>
                            <span className="Error">{ErrorMSG["pincode"]}</span>
                            {(sharedData.cityName && sharedData.stateName && pincode.length === 6) && < span className="city_state_name" > { sharedData.cityName }, { sharedData.stateName }</span>}
                        </div>
                    </div>
                    <div className="EditDetailsFooter">
                        <button className={`SMCBTN ${isBtnDisabled ? "disable":""}`} id="quotesBtn" name="Member" disabled={isBtnDisabled} onClick={(e) => updateEditedDetails(e)}>{btnVal}</button>
                    </div>
                </div>
                
            </div>
        </>
    );
}
export default EditDetailsModal;